'use client';

import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  resetPasswordFormSchema,
  ResetPasswordFormValues,
} from '@/features/auth/internal/schemas/reset-password-form.schema';
import { resetPassword } from '@/features/auth/internal/helpers/browser-clients/reset-password';
import { ResetPasswordSocialOnlyError } from '@/features/auth/shared/api/errors/client-auth-errors';

export const useResetPassword = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [successEmail, setSuccessEmail] = useState('');

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
  } = useForm<ResetPasswordFormValues>({
    resolver: zodResolver(resetPasswordFormSchema),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = async (values: ResetPasswordFormValues) => {
    try {
      await resetPassword(values.email);
      setSuccessEmail(values.email);
      setIsSuccess(true);
    } catch (err) {
      console.error(err);
      if (err instanceof ResetPasswordSocialOnlyError) {
        setError('root', { message: 'errors.socialOnly' });
        return;
      }
      setError('root', { message: 'errors.unexpectedError' });
    }
  };

  return {
    register,
    handleSubmit,
    errors,
    isSubmitting,
    onSubmit,
    isSuccess,
    successEmail,
  };
};
